import TableHeader, { TableHeaderOptions } from '@tiptap/extension-table-header';
import { ResourceType } from './types';

const contentExpr = {
  page: '(paragraph | bulletList | orderedList | taskList | heading | stImageGroup)+',
  comment: '(paragraph | bulletList | orderedList | taskList)+',
  card: '(paragraph | bulletList | orderedList | taskList | heading | stImageGroup)+',
  board: '(paragraph)+',
  note: '(paragraph | bulletList | orderedList | taskList | heading | stImageGroup)+',
};

export default TableHeader.extend<TableHeaderOptions & { resourceType?: ResourceType }>({
  addOptions() {
    return {
      ...this.parent?.(),
      resourceType: undefined,
    };
  },
  content() {
    if (!this.options.resourceType) {
      return '(paragraph)+';
    } else {
      return contentExpr[this.options.resourceType];
    }
  },
});
